import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import './registerServiceWorker'
import moment from 'moment/src/moment'
import VueFriendlyIframe from 'vue-friendly-iframe'
import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
import CircularOverlay from './components/CircularOverlay.vue'

Amplify.configure(aws_exports);

Vue.config.productionTip = false
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})
Vue.component('CircularOverlay', CircularOverlay)

Vue.use(VueFriendlyIframe)


new Vue({
  router,
  store,
  vuetify,
  //sets user state to current localstorage in
  // case of refresh
  created() {
    const userString = localStorage.getItem('user')
    if(userString) {
      const userData = JSON.parse(userString)
      this.$store.commit('SET_USER_DATA', userData)
    }

    // *** saftey measure to avoid use of fake tolkens
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$store.dispatch('logout')
        }
        return Promise.reject(error)
      }
    )
  },
  render: h => h(App)
}).$mount('#app')